import { render, staticRenderFns } from "./QuestionnaireSection.vue?vue&type=template&id=61998c14&scoped=true"
import script from "./QuestionnaireSection.vue?vue&type=script&lang=js"
export * from "./QuestionnaireSection.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireSection.vue?vue&type=style&index=0&id=61998c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61998c14",
  null
  
)

export default component.exports